export const NotificationDefaultIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="#1F2233"
    />
    <path
      d="M11.3 8.50004L12.7 8.50004V13.4H11.3V8.50004ZM11.3 15.5L12.7 15.5V14.1H11.3V15.5ZM17.6 12C17.6 13.1076 17.2716 14.1903 16.6563 15.1112C16.0409 16.0321 15.1663 16.7499 14.1431 17.1738C13.1198 17.5976 11.9938 17.7085 10.9075 17.4924C9.82123 17.2764 8.8234 16.743 8.04023 15.9598C7.25705 15.1767 6.72371 14.1788 6.50763 13.0925C6.29155 12.0062 6.40245 10.8803 6.8263 9.85701C7.25015 8.83375 7.96792 7.95915 8.88883 7.34381C9.80975 6.72847 10.8924 6.40004 12 6.40004C12.7354 6.40004 13.4636 6.54489 14.1431 6.82631C14.8225 7.10774 15.4398 7.52023 15.9598 8.04024C16.4798 8.56025 16.8923 9.17759 17.1737 9.85701C17.4552 10.5364 17.6 11.2646 17.6 12ZM16.48 12C16.48 11.114 16.2173 10.2478 15.725 9.51108C15.2327 8.77435 14.5331 8.20014 13.7144 7.86106C12.8958 7.52198 11.9951 7.43326 11.126 7.60612C10.257 7.77898 9.45873 8.20566 8.83219 8.8322C8.20565 9.45874 7.77897 10.257 7.60611 11.126C7.43325 11.9951 7.52197 12.8958 7.86105 13.7145C8.20013 14.5331 8.77434 15.2328 9.51107 15.725C10.2478 16.2173 11.114 16.48 12 16.48C13.1877 16.4786 14.3264 16.0061 15.1662 15.1662C16.0061 14.3264 16.4785 13.1878 16.48 12Z"
      fill="#8388A3"
    />
  </svg>
);
